import React from 'react'


import {
  classnames,
  Icon,
  VisibilityOff,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function ModelCardOverlay({
  isImageAgeRestricted = false,
  isGalleryOpened = false,
  onClick = NOOP,
}) {
  return (
    <span
      className={classnames(
        'card-3d-model__overlay',
        isGalleryOpened && 'card-3d-model__overlay--gallery-opened',
        isImageAgeRestricted && 'card-3d-model__overlay--image-age-restricted'
      )}
      onClick={onClick}
    >
      {isGalleryOpened ? 'PREVIEWING' : <Icon notSpaced color="light" svgComponent={VisibilityOff} />}
    </span>
  )
}

ModelCardOverlay.propTypes = {
  isImageAgeRestricted: bool,
  isGalleryOpened: bool,
  onClick: func,
}

export default ModelCardOverlay
